<script>
	import PageSection from "../../components/PageSection.svelte";
	import IFrame from "../../components/IFrame.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { pageNumber, model } from "../../stores";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let nextPageLabel = null;
	export let lastVisitedPage = null;

	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	//  Check for the back button
	if ($pageNumber == 5) {
		alert("The form has already been submitted.");
		window.location.href = "/";
	} else {
		pageNumber.update((p) => pageIndex);
	}

	let url = `/documents/RubyPrincess - AgreementsAcceptance - Litigation Funding Agreement.pdf`;
	let statementUrl = `/documents/RubyPrincess - AgreementsAcceptance - Conflicts Disclosure Statement.pdf`;
	let pollUrl = `/documents/RubyPrincess - AgreementsAcceptance - Deed Poll.pdf`;
</script>

<PageSection>
	<h2>Funding Agreement</h2>

	<div class="top_cont">
		<div class="form_cont">
			<IFrame height="800px" title="RubyPrincess - AgreementsAcceptance - Litigation Funding Agreement" {url}
			></IFrame>
		</div>
	</div>

	<div class="form-row form-group">
		<div class="col-md-12">
			<p>
				If you are having trouble viewing the agreement or would like to download a copy please click <a
					href={url}
					title="RubyPrincess - AgreementsAcceptance - Litigation Funding Agreement"
					target="_blank">here</a
				>.
			</p>
			<p>
				Download Conflicts Disclosure Statement <a
					href={statementUrl}
					title="RubyPrincess - AgreementsAcceptance - Conflicts Disclosure Statement"
					target="_blank">here</a
				>
			</p>
			<p>
				Download Deed Poll <a
					href={pollUrl}
					title="RubyPrincess - AgreementsAcceptance - Deed Poll"
					target="_blank">here</a
				>
			</p>
		</div>
	</div>

	<form novalidate autocomplete="off">
		<div class="form-row">
			<div class="col-md-12">
				<Checkbox bind:checked={$model.LFAConfirmed} label="Confirm Funding Agreement" required="true" id="af"
				></Checkbox>
			</div>
		</div>

		<div class="form-row button-row">
			<div class="col-md-12 last">
				<NavigationButtons {persistUrl} {previousPage} {nextPage} {nextPageLabel}></NavigationButtons>
			</div>
		</div>
	</form>
</PageSection>

<style>
	.top_cont {
		margin: 0 auto 20px auto;
	}

	.button-row {
		margin-top: 40px;
	}

	@media (max-width: 768px) {
		.button-row .last {
			text-align: center;
		}
	}
</style>
